export enum CategoryError {
	CATEGORY_ERROR = 'There was an error loading categories. Please try again.',
	DELETE_ERROR = 'Error deleting category',
	EDIT_ERROR = 'Error editing category',
	CREATE_ERROR = 'Error creating category',
	NAME_ERROR = 'Category name is required',
	DESCRIPTION_ERROR = 'Category description is required',
	PRIVACITY_ERROR = 'Category privacity is required',
}

export enum CategoryMessage {
	DELETE_MESSAGE = 'Are you sure you want to delete?',
	UPDATE_MESSAGE = 'Category updated successfully',
	CREATE_MESSAGE = 'Category created successfully',
}
